module.exports = "::ng-deep .trip-rating-dialog-panel .mat-dialog-container {\r\n    padding: 24px !important;\r\n    border-radius: 8px !important;\r\n    overflow-y: auto !important;\r\n}\r\n\r\n/* Ensure proper spacing for the form content */\r\n\r\n.trip-rating-dialog {\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.comment {\r\n    width: 100%;\r\n    min-height: 100px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/user-dashboard/trip-rating-dialog/trip-rating-dialog.component.css
// module id = ./src/app/user-dashboard/trip-rating-dialog/trip-rating-dialog.component.css
// module chunks = main